export function graphql(): string {
  return 'graphql';
}
export * from './graphql.handler';
export * from './graphql.client';
